import { Link } from 'react-router-dom';
import type { Store } from '@geely/shared';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@geely/ui';
import { CheckCircle2, Calendar, Clock, MapPin, Copy, Check } from 'lucide-react';
import { formatDate, formatTime } from '@/lib/utils';

interface ConfirmationStepProps {
  appointmentId: string;
  selectedStore: Store;
  selectedDate: string;
  selectedTime: string;
  isRescheduling: boolean;
  copied: boolean;
  onCopy: () => void;
}

export function ConfirmationStep({
  appointmentId,
  selectedStore,
  selectedDate,
  selectedTime,
  isRescheduling,
  copied,
  onCopy,
}: ConfirmationStepProps) {
  return (
    <Card>
      <CardHeader className="text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-[#000000]/10 rounded-full mb-4 mx-auto">
          <CheckCircle2 className="size-8 text-[#000000]" />
        </div>
        <CardTitle className="text-2xl">
          {isRescheduling ? 'Agendamento Remarcado!' : 'Agendamento Confirmado!'}
        </CardTitle>
        <CardDescription>
          Seu agendamento foi {isRescheduling ? 'remarcado' : 'realizado'} com sucesso
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="text-center">
          <p className="font-medium mb-2 text-[#080404]">Guarde este ID para consultar seu agendamento:</p>
          <div className="flex items-center gap-2 bg-[#000000]/5 border border-[#000000]/20 rounded-md px-4 py-3">
            <p className="flex-1 text-lg font-mono font-bold text-[#000000] truncate text-left">{appointmentId}</p>
            <Button
              variant="ghost"
              size="sm"
              className="shrink-0"
              onClick={onCopy}
            >
              {copied ? <Check className="size-4 text-green-600" /> : <Copy className="size-4" />}
            </Button>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <MapPin className="size-5 text-[#000000] mt-0.5" />
            <div>
              <p className="font-medium text-[#080404]">Loja</p>
              <p className="text-sm text-[#64748b]">{selectedStore.name}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Calendar className="size-5 text-[#000000] mt-0.5" />
            <div>
              <p className="font-medium text-[#080404]">Data</p>
              <p className="text-sm text-[#64748b]">{formatDate(selectedDate)}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Clock className="size-5 text-[#000000] mt-0.5" />
            <div>
              <p className="font-medium text-[#080404]">Horário</p>
              <p className="text-sm text-[#64748b]">{formatTime(selectedTime)}</p>
            </div>
          </div>
        </div>

        <div className="pt-4 space-y-3">
          <Link to="/client/lookup">
            <Button variant="outline" className="w-full">
              Consultar Agendamento
            </Button>
          </Link>
          <Link to="/">
            <Button className="w-full">
              Voltar à Página Inicial
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
